import { render, staticRenderFns } from "./matter_rpt.vue?vue&type=template&id=40762edc&"
import script from "./matter_rpt.vue?vue&type=script&lang=ts&"
export * from "./matter_rpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports